import type { FaireProductEntity } from "../../entity_types/product";

export const p_423xxf5825: FaireProductEntity = {
  token: "p_423xxf5825",
  type: "product",
  name: "“Game Day” Fuzzy Chenille Clear Crossbody Bag",
  brandToken: "b_vswk7rntc2",
  brandName: "SP Sophia Collection",
  imageUrl:
    "https://cdn.faire.com/fastly/30b39da7f1a7d9e78553d9f3cb60527b15cf4db8cbca619ba56c56b3c0bec9e1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6fe00e13c624bcccf5411cc5cb39d58b9e726d7854a7ede2b44381cd5bcbbc53.jpeg",
    "https://cdn.faire.com/fastly/1d8752bb6c327826119a076fedea26ae119f728c063fd7b294a093bfec6e0132.jpeg",
    "https://cdn.faire.com/fastly/021b7276d55dde91919363d859de9432fe4a03ef62b9952fbcc9e12bb0d325e4.jpeg",
    "https://cdn.faire.com/fastly/400923669844916e642dab1f2caf640749ffa97eaf0d7b58150524c6be863d68.jpeg",
    "https://cdn.faire.com/fastly/ee0113f74098d757c9662bdf3cd9ebae5a56f635255bbc7a14605bdaef3b1b83.jpeg",
    "https://cdn.faire.com/fastly/de41390a387030470848bd359be0009c0cac8ea12f9eeb6d44de861f2457bd6b.jpeg",
    "https://cdn.faire.com/fastly/895db76b76d5b374b4dca759e8a3c1ed65c620596023c1c7485a574d19c65dac.jpeg",
  ],
  priceDollars: 10.2,
  description:
    'Dimensions\nHeight: 6.5" \nWidth: 8.5" \nDepth: 1.5" (Approx. 1.4 Liters)\n\nKey Features\nDesigned for stadium events, concerts, and school games, this clear crossbody bag keeps you compliant and stylish with its transparent body and bold “GAME DAY” chenille patch. The water-resistant material, secure zipper closure, and adjustable decorative strap offer a functional yet fashionable way to carry essentials. Lightweight and easy to clean, it’s the perfect grab-and-go bag for spirited fans and active students.\n\nPerfect For\nSports games, pep rallies, tailgates, concerts, school spirit events, and stadium-approved outings. A must-have for students, cheerleaders, and fans who need hands-free, policy-ready access without sacrificing style.',
  tags: [],
  msrpDollars: 40.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:25:53.242Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
